import { useFeatureFlag } from '@glossgenius/core-features-react-sdk';

import { FEATURE_FLAGS } from 'core-features-config/activeFeatureFlags';

export const useBnplFeatureFlag = () => {
  const { isEnabled, isLoading } = useFeatureFlag(FEATURE_FLAGS.BNPL);

  return { isEnabled, isLoading };
};

export const useBnplSettingsFeatureFlag = () => {
  const enableBNPL = useBnplFeatureFlag();
  const enableBNPLSettings = useFeatureFlag(FEATURE_FLAGS.BNPL_SETTINGS);
  const enableBNPLPromotion = useFeatureFlag(FEATURE_FLAGS.BNPL_PROMOTION);
  const enableBNPLDynamicPaymentMethods = useFeatureFlag(
    FEATURE_FLAGS.BNPL_DYNAMIC_PAYMENT_METHODS,
  );

  return {
    isEnabled:
      enableBNPL.isEnabled &&
      enableBNPLSettings.isEnabled &&
      enableBNPLPromotion.isEnabled,
    isDynamicPaymentMethodsEnabled:
      enableBNPL.isEnabled && enableBNPLDynamicPaymentMethods.isEnabled,
    isLoading:
      enableBNPL.isLoading ||
      enableBNPLSettings.isLoading ||
      enableBNPLPromotion.isLoading ||
      enableBNPLDynamicPaymentMethods.isLoading,
  };
};
